import gql from 'graphql-tag';

export const RUN_LOG_LINES_QUERY = gql`
  query RunLogLines(
    $projectName: String!
    $entityName: String
    $runName: String!
    $last: Int
    $before: String
    $first: Int
    $after: String
    $useImprovedPagination: Boolean = false
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      run(name: $runName) {
        id
        state @include(if: $useImprovedPagination)
        logLines(
          after: $after
          before: $before
          first: $first
          last: $last
          useImprovedPagination: $useImprovedPagination
        ) {
          edges {
            node {
              id
              label
              level
              line
              number
              timestamp
            }
          }
          pageInfo {
            endCursor
            hasNextPage
            hasPreviousPage
            startCursor
          }
        }
      }
    }
  }
`;
